import 'imask/esm';
export { I as IMaskMixin } from './mixin-1cb78d9b.js';
export { default as IMaskInput } from './input.js';
import 'react';
import 'prop-types';
import 'imask/esm/imask';
